const VERIFIED_STATUSES = new Set([
  "verified",
  "active",
  "approved",
  "true",
  "1",
]);

function isVerifiedAccount(account = {}) {
  if (typeof account.is_verified === "boolean") return account.is_verified;
  if (typeof account.isVerified === "boolean") return account.isVerified;

  const status = String(
    account.verification_status || account.status || ""
  ).toLowerCase();

  return VERIFIED_STATUSES.has(status);
}

/** Map player API UPI account to the shape used by UPI ID UI. */
export function normalizeUpiAccount(account = {}) {
  return {
    ...account,
    upiAccountId: account.id || account.upi_account_id || "",
    upiId: account.upi_id || account.upiId || "",
    accountName: account.account_name || account.accountName || "",
    accountHolderName:
      account.account_holder_name || account.accountHolderName || "",
    qrCodeUrl: account.qr_code_url || account.qrCodeUrl || "",
    verificationStatus: (
      account.verification_status ||
      account.verificationStatus ||
      ""
    ).toLowerCase(),
    isVerified: isVerifiedAccount(account),
    isPrimary: Boolean(account.is_primary ?? account.isPrimary),
    isActive: account.is_active ?? account.isActive ?? true,
    payoutMethod: account.payout_method || account.payoutMethod || "upi",
    createdAt: account.created_at || account.createdAt || "",
  };
}

export function normalizeUpiAccounts(accounts = []) {
  if (!Array.isArray(accounts)) return [];
  return accounts.map(normalizeUpiAccount);
}
